// en, it
export default {
  en: {
    Welcome: 'Welcome to Appointment Application',
    Dashboard: 'Dashboard',
    Companies: 'Companies',
    Register: 'Register',
    ForgotPassword: 'Forgot password?',
    ResetPassword: 'Reset password',
    Error: 'Error',
    404: '404',
    500: '500',
    Profile: 'Profile',
    User: 'User',
    Users: 'Total users',
    View: 'View',
    Edit: 'Edit',
    Import: 'Import',
    Settings: 'Settings',
    FirstName: 'First name',
    LastName: 'Last name',
    PrivacyPolicy: 'Privacy policy',
    Cancel: 'Cancel',
    ContactNumber: "Contact number",
    AdminLogin: 'Admin login',
    Email: 'Email',
    Password: 'Password',
    //add new
    EnterPassword: 'Enter password',
    //
    Login: 'Login',
    LoginWelcome: "Welcome back, please login to your account.",
    Recoveryourpassword: 'Recover your password',
    RecoveryourpasswordText: "Please enter your email address and we'll send you instructions on how to reset your password.",
    BackToLogin: 'Back to login',
    RecoverPassword: 'Recover password',
    ResetPassword: 'Reset password',
    ResetPasswordText: 'Please enter your new password.',
    ConfirmPassword: 'Confirm password',
    Reset: 'Reset',
    TotalCompanies: 'Total companies',
    Action: 'Action',
    NA: 'N/A',
    StaffDetails: 'Staff details',
    Back: 'Back',
    DepartmentName: 'Department name',
    AddStaff: 'Add staff',
    EditStaff: 'Edit staff',
    Departments: 'Departments',
    Submit: 'Submit',
    CompanyLogin: "Company login",
    Staffs: 'Staffs',
    Appointments: 'Appointments',
    TotalStaffs: 'Total staffs',
    TotalDepartments: 'Total departments',
    TotalAppointments: 'Total appointments',
    //14/09/2020
    EnterOTP: 'Enter OTP',
    EnterOTPPlaceholder: 'Enter OTP placeholder',
    TotalSms: 'Total SMS',
    SendOTP: "Send OTP",
    Validate: "Validate",
    InvalidOTP: "Invalid OTP",
    OTPVerified: "OTP  has been Verified successfully",
    ValidaionPhoneNumber: "OTP has been sent successfully",
    NotificationSettings: "Notification settings",
    TrackingLogs: "Tracking logs",
    Title: "Title",
    TitleName: "Title name",
    TitlePlaceholder: "Enter title name",
    Enabled: "Enabled",
    Disabled: "Disabled",
    Department: 'Department',
    Update: 'Update',
    Cancel: 'Cancel',
    Export: 'Export',
    Show: 'Show',
    Delete: 'Delete',
    Number: 'Number',
    NoData: 'No data available',
    CurrentStatus: 'Current status',
    StartTime: 'Start time',
    EndTime: 'End time',
    Staff: 'Staff',
    Day: 'Day',
    Date: 'Date',
    Add: 'Add',
    AddDepartment: 'Add department',
    EditDepartment: 'Edit department',
    DepartmentName: 'Department name',
    DepartmentPlaceholder: 'Enter department name',
    Description: 'Description',
    DescriptionPlaceholder: 'Enter department desciption',
    BookingMessage: 'Booking message',
    BookingMessagePlaceholder: 'Enter booking message',
    AppointmentDuration: 'Appointment duration',
    AppointmentDurationPlaceholder: 'Enter appointment duration in minutes',
    //staff login
    TimeSlot: 'Time slot',
    CustomSlot: 'Custom slot',
    Slot: 'Slot',
    AddMore: 'Add more',
    Save: 'Save',
    SelectDate: 'Select date',
    CustomTimeSlot: 'Custom time slot',
    Logout: 'Logout',
    Change: 'Change',
    ConfirmPassword: 'Confirm password',
    EditProfile: 'Edit profile',
    CompanyName: 'Company name',
    OpeningHours: 'Opening hours',
    WelcomeMessage: 'Welcome message',
    HeaderFooter: 'Header/Footer',
    CompanyNamePlaceholder: 'Enter company name',
    PasswordPlaceholder1: 'Your password',
    WelcomeMessagePlaceholder: 'Enter welcome message',
    OpeningHoursPlaceholder: 'Enter opening hours',
    FirstNamePlaceholder: 'Enter first name',
    LastNamePlaceholder: 'Enter last name',
    WelcomeToDashboard: 'Welcome to dashboard',
    FailedToLogin: 'Failed to login',
    Incorrectpassword: 'Incorrect password',
    Emailnotregistered: 'Email not registered',
    EmailSent: 'Email sent',
    LinkSent: "Link sent please check your email",
    PasswordReset: "Password reset successfully",
    SetPassword: 'Set password',
    InvalidToken: 'Invalid token',
    TokenExpired: 'Token expired',
    SignUp: 'Sign Up',
    ThankYou: 'Thank you for registration!!',
    ThankYouText: 'Your request is under approval, you will receive an email soon.',
    Theemailhasalreadybeentaken: 'The email has already been taken.',
    emailalreadyexists: 'Email already exists',
    ExportToExcel: 'Export to Excel',
    FileName: 'Enter file name',
    CellAutoWidth: 'Cell auto width',
    Status: 'Status',
    Approved: 'Approved',
    DeleteCompany: 'Are you sure to delete this company?',
    Yes: 'Yes',
    No: 'No',
    CompanyDeleted: 'Company has been delete successfully',
    ApproveCompany: "Are you sure you want to approve this company?",
    CompanyApproved: 'Company has been approved successfully',
    AddCompany: 'Add company',
    EmailPlaceholder: 'Enter email',
    PasswordPlaceholder: 'Enter password',
    CompanySlug: 'Company slug',
    CompanySlugPlaceholder: 'Enter company slug',
    CompanyAdded: 'Company has beed added successfully',
    CompanyUpdated: 'Company has been updated successfully',
    EditCompany: 'Edit company',
    Emailisalreadytakenpleasetrywithdiffrentemail: 'Email is already taken please try with diffrent email',
    Requestfailedwithstatuscode401: 'Unauthorized, please login again',
    ConfirmPasswordPlaceholder: 'Enter confirm password',
    FileUpload: 'File upload',
    Upload: 'Upload',
    FileUploadError: 'Please upload file having extensions .jpeg .jpg .png .gif only.',
    ProfileUpdated: 'Profile has been updated successfully',
    ConfiredPasswordFailed: 'Confired password failed',
    SettingUpdated: 'Setting has been updated successfully',
    CompanyNotFound: 'The company you are looking for could not be found!!',
    Open: 'Open',
    Forenquiry: 'For enquiry',
    SelectDataTime: 'Select date and time',
    SelectDataTime1: 'Or Select date and time',
    dayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    TimeSlotNotAvailable: 'Timeslot not available for this department',
    Confirmed: 'Confirmed',
    AppointmentBookedText: 'Your appointment scheduled with ',
    AppointmentBookedText1: 'Your appointment ',
    AppointmentBookedTextUnio: 'The next appointment ',
    //new
    AppointmentBookedText2: 'Your appointment with ',

    EmailReceive: 'You will receive your username and password via email at',
    AddToCalender: 'Add to your calendar',
    Confirm: 'Confirm',
    EnterDetails: 'Enter details',
    AccountText: 'If you have an account you can',
    EventScheduled: 'Event scheduled successfully!',
    UserRegistredSuceessfullybutstaffnotavailable: 'User registred suceessfully but staff not available',
    RoomError: 'Room not available!!',
    RoomError1: 'Room is full, please contact to admin.',
    ScheduleEvent: 'Schedule event',
    Pending: 'Pending',
    Completed: 'Completed',
    Complete: 'Complete',
    CancelAppointment: 'Cancel appointment',
    Reason: 'Reason',
    EnterReason: 'Enter reason',
    Accept: 'Accept',
    AppointmentAcceptSucess: 'Appointment accepted successfully',
    AppointmentAccept: 'Appointment accepted',
    Reject: 'Reject',
    RejectAppointment: 'Reject appointment',
    AppointmentRejectedSucess: 'Appointment rejected successfully',
    AppointmentRejected: 'Appointment rejected',
    AppointmentCanceledSucess: 'Appointment cancelled successfully',
    WantToCompletedStatus: 'Are you sure you want to completed status this appointment?',
    AppointmentCanceled: 'Appointment cancelled',
    AppointmentCompleted: 'Appointment completed',
    AppointmentMarkedCompleted: 'Appointment marked as completed',
    FailedToUpdateStatus: 'Failed to update status',
    AppointmentDetails: 'Appointment details',
    ConferenceLink: 'Conference link',
    ConferencePin: 'Conference pin',
    ProfileUpdate: 'Profile update',
    ProfileUpdateSuccess: 'Profile updated successfully',
    FailedToFetchUsers: 'Failed to fetch users',
    TimeSlotAdded: 'Time slot added successfully',
    StartDateError: 'Start time should not be  in the range of selected  time slot',
    StartDateRangeError: 'Start time should not be  in the range of selected  time slot',
    StartTimeLessErr: 'Start time should be  less than end time',
    EndtDateError: 'End time should not be  in the range of selected  time slot',
    EndDateRangeError: "Start time should not be in the range of selected  time slot",
    EndTimeLessError: "End time should be  greater than start time",
    StaffDeleted: "Staff has been deleted successfully",
    DeleteStaffMessage: "Are you sure to delete the Staff?",
    SelectDepartments: 'Select departments',
    DepartmentError: 'The departments field is required',
    StaffAdded: 'Staff has been added successfully',
    SMTPAdded: 'SMTP has been added successfully',
    SMTPUpdated: 'SMTP has been updated successfully',
    StaffUpdated: 'Staff has been updated successfully',
    Duration: 'Duration',
    DepartmentDeleted: "Department has been deleted successfully",
    DeleteDepartmentMessage: "Are you sure to delete the Department?",
    DepartmentAdded: "Department has been added successfully",
    DepartmentUpdated: "Department has been updated successfully",
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Lunedi: 'Monday',
    Martedì: 'Tuesday',
    Mercoledì: 'Wednesday',
    Giovedi: 'Thursday',
    Venerdì: 'Friday',
    Sabato: 'Saturday',
    Domenica: 'Sunday',
    //rahul added
    StaffLogin: "Staff login",
    Rights: 'All rights reserved',
    DefaultSlot: 'Default slot',
    CustomSlot: 'Custom slot',
    //new add
    Youraccountisnotbeenapprovedyetpleasecontactadmin: 'Your account is not been approved yet please contact admin',
    Yourcardnumberisincomplete: 'Your card number is incomplete.',
    Yourcardsexpirationyearisinthepast: "Your card's expiration year is in the past.",
    Yourcardssecuritycodeisincomplete: "Your card's security code is incomplete.",
    Yourcardnumberisinvalid: 'Your card number is invalid.',
    Yourcardsexpirationdateisincomplete: "Your card's expiration date is incomplete.",
    Yourpostalcodeisincomplete: 'Your postal code is incomplete.',
    Yourcardisnotsupported: 'Your card is not supported.',
    CardHolderName: 'Card holder name',
    CardNumber: 'Card number',
    ExpiryDate: 'Expiry date',
    CardCVC: 'Card CVC',
    PaymentDetails: 'Payment details',
    PayNow: 'Pay now',
    PaymentMsg: 'This appointment requires a payment. You can pay using your debit or credit card.',
    OnDate: 'On date',
    ContactText: 'If you have any query you can contact on ',
    AppointmentBooked: 'Appointment booked',
    CreditDebitCard: 'Credit or debit card',
    PaymentDone: 'Payment has been done successfully.',
    Pay: 'Pay',
    Name: 'Name',
    Amount: "Amount",
    AmountPlaceholder: "Enter amount",
    Currency: "Currency",
    CurrencyPlaceholder: "Select currency",
    //new added 27/07/2020
    PaymentStatus: "Payment status",
    Paid: "Paid",
    NotPaid: "Not paid",
    //new added 29/07/2020
    UserRegistredSuceessfullybutstaffnotavailable: "User registred suceessfully but staff not available",
    UserLoggedInSuccessfullybutstaffnotavailable: 'User logged in successfully but staff not available',
    SettingSlot: "Time slot setting",
    Paymentfailed: 'Payment failed, please try again!',
    AppointmentNotFound: 'Appointment not found',
    //added 4/08/2020
    Payments: "Payments",
    Company: "Company",
    PaymentDate: "Payment date",
    UserDetails: "User details",
    DepartmentDetails: "Department details",
    CompanyDetails: "Company details",
    PaymentId: "Payment id",
    //added 7/08/2020
    SelectSplitBy: "Select split by",
    SelectDateRange: "Select date range",
    // added 11/08/2020
    SelectStatus: "Select status",
    TotalRevenue: 'Total revenue',
    //added 13/08/2020
    Today: "Today",
    Last7Days: "Last 7 days",
    LastMonth: "Last month",
    CurrentMonth: "Current month",
    LastYear: "Last year",
    CurrentYear: "Current year",
    TodaysRevenue: "Todays revenue",
    Last7DaysRevenue: "Last 7 days revenue",
    LastMonthRevenue: "Last month revenue",
    CurrentMonthRevenue: "Current month revenue",
    LastYearRevenue: "Last year revenue",
    CurrentYearRevenue: "Current year revenue",
    TodaysAppointment: "Todays appointment",
    Last7DaysAppointment: "Last 7 days appointment",
    LastMonthAppointment: "Last month appointment",
    CurrentMonthAppointment: "Current month appointment",
    LastYearAppointment: "Last year appointment",
    CurrentYearAppointment: "Current year appointment",
    AppointmentStatus: 'Appointment status',
    Unpaid: 'Unpaid',
    Revenue: 'Revenue',
    //17/08/2020
    Rooms: "Rooms",
    CreateRoom: "Create room",
    CreateRoomPlaceholder: "Create new room ",
    RoomName: "Room name",
    DeleteRoom: "Are you sure to delete the Room?",
    RoomDeleted: "Room has been delete successfully",
    RoomAdded: "Room has been added successfully",
    RoomPin: 'Pin',
    //added 19/08/2020
    LatestAppointment: "Latest appointment",
    SystemSettings: 'Whitelabel settings',
    SelectPlan: 'Select plan',
    Plan: ' Plan',
    SystemSettingsUpdated: 'Whitelabel settings has been updated successfully',
    RoomAddress: 'Room address',
    MaxParticipants: 'Max participants',
    Upgrade: 'Upgrade',
    RoomUpdated: 'Room has been updated successfully',
    DurationUpdated: 'Meeting duration has been updated successfully',
    CopyText: 'Copy successfully',
    CopyTextError: 'Unable to copy code',
    AppError: 'Appointment not found',

    //10/09/2020
    // UserNotConnect: 'didnt connect yet. Please wait till the meeting will start',
    UserNotConnect: " The meeting has not started yet. Please wait for the host to open it.",

    EditRoom: 'Edit room',
    EmbedCode: 'Embed book appointment',
    //added 27/08/2020
    URLMessage: "URL where code  embedded",
    //28/08/2020
    ClearTimeSlot: 'Clear time slot successfully',
    Clear: "Clear slots",
    Ordinary: 'Ordinary',
    Exceptions: 'Exceptions',
    Workshift: 'Work shift',
    OrdinaryWorkshift: 'Ordinary work shift',
    SelectWeekDays: 'Select week days',
    Days: "Days",
    OpeningDays: 'Opening days',
    OpeningTime: 'Opening time',
    ClosingTime: 'Closing time',
    OridinaryExplainationBox: 'Define your working week. Based on your working week, the platform will calculate your available time and schedule appointments for you. You can define multiple slots in the same week day, for example one in the morning and one in the afternoon, leaving a lunch break in the middle.',
    ExceptionsExplainationBox: 'Here you can define the exceptions to your ordinary working week. If you requested a leave for a specific day, you can select the date and remove or adjust the related work shift.',
    //02/09/2020
    DirectURL: "Direct URL",
    MeetingDuration: "Meeting duration",
    Duration: "Duration",
    VisiblityUpdated: "Visiblity  has been updated successfully",
    StatusUpdated: "Status has been updated successfully",
    Visiblity: "Visiblity",
    //03/09/2020
    Free: "Free",
    SetVisibility: 'Set visibility',
    RemoveVisibility: 'Remove visibility',
    PremiumMeeting: "Premium meeting",
    DepartmentSlug: "Department slug",
    DepartmentSlugPlaceholder: "Department slug placeholder",
    //04/09/2020
    Copy: "Copy",
    ManyToMany: "Many to many",
    Booked: 'Already booked',
    BookedAppointmentText: 'Your appointment already booked',
    AppointmentStatistics: "Appointment statistics",
    ScheduleAt: 'is scheduled at:',
    DidNotConnected: 'did not connected yet',
    StartWithVideo: 'Start with video',
    StartWithMicroPhone: 'Start with microphone',
    StartTheMeeting: 'Start the meeting',
    Absent: "Absent",
    Present: "Present",
    On: "On",
    Off: "Off",
    Welcome1: "Welcome",
    //16/09/2020
    Meeting: "Meeting",
    SelectMeeting: "Select meeting",
    TypeOfMeeting: "Type of meeting",
    TypeOfMeetingPlaceholder: "Select type of meeting",
    FreeMeeting: "Free meeting",
    OneToOne: "One to one",
    Onetoone: "One to one",
    Unoauno: "One to one",
    Conference: "Conference",
    Conferenza: "Conference",
    EmbedYourWebsite: 'Embed in your website',
    CompnayId: 'Compnay id',
    AppointmentBookingWidget: 'Appointment booking widget',
    AppointmentBookingWidgetText: 'This is the appointment booking widget for this company. Copy and paste this code in the page of your website where you want to embed the Appointment system.',
    MeetingRoomWidget: 'Meeting room widget',
    MeetingRoomWidgetText: 'This Widget, is different for each room because it contains the Room ID. Select the room that you want to embed, and copy and paste this code in the page of your website where you want to embed that room. Then input the URL where you embedded the room, so we know where to send your meetings’ attendees. ',
    RoomURL: 'Room URL on your website',
    UserOnline: 'is Online',
    UserOffline: 'is Offline',
    Offline: 'Offline',
    Online: 'Online',
    BookingForm: 'Booking form',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    contact_number: 'Contact number',
    company_name: 'Company',
    gender: 'Gender',
    age: 'Age',
    dob: 'Birthday date',
    country: 'Country',
    city: 'City',
    document: 'Identity document',

    Passport: 'Passport',
    IdentityCard: "Identity card",
    DrivingLicense: "Driving license",
    custom_field_one: 'Custom 1',
    custom_field_two: 'Custom 2',
    Custom1Label: 'Custom 1 label',
    Custom2Label: 'Custom 2 label',
    DateOfBirth: "Date of dirth",
    EnterLabel: 'Enter label',
    FieldsSaved: 'Fields has been updated successfully',
    Male: 'Male',
    Female: 'Female',
    Maschio: "Male",
    Femmina: "Female",
    Prefernottosay: 'Prefer not to say',
    Enter: 'Enter ',
    Select: 'Select ',
    //24/09/2020
    SMTP: "SMTP",
    Server: "Server",
    ServerPlaceholder: "Enter server URL",
    Port: "Port",
    PortPlaceholder: "Enter port",
    UserName: "Username",
    UserNamePlaceholder: "Enter username",
    SenderEmailAddress: "Sender email",
    SenderEmailPlaceholder: "Enter sender email",
    ServerAddress: "Server address",
    UseUnio: "Use unio",
    UseOwn: "Use own",
    SelectSMTP: "Select SMTP",
    //Added 28/09/2020
    TimeZone: "Time zone",
    SelectTimeZone: "Select time zone",
    TimeZoneAdded: 'Time zone has been added successfully',
    TimeZoneUpdated: 'Time zone has been updated successfully',
    //Added 1/10/2020
    Shown: "Shown",
    Mandatory: "Mandatory",
    //31/08/2020
    DeleteUser: 'Are you sure to delete this User?',
    UserDetails: 'User details',
    UserDeleted: "User has been deleted successfully",
    User1: "Users",
    SelectLanguage: "Select language",
    Language: "Language",
    English: "English",
    Italian: "Italian",
    //5/10/2020
    VideoConfereceEngine: "Video conference engine",
    VideoConferece: "Video conference",
    EnginePlaceholder: "Enter video conference engine",
    Domain: "Domain",
    DomainPlaceholder: "Enter domain",
    VideoConferenceUpdated: "Video conference has been updated successfully",
    //9/10/2020
    Month: "Month",
    Year: "Year",
    Week: "Week",
    //15/10/2020
    Role: "Role",
    SelectRole: "Select Role",
    Admin: "Admin",
    //new added 29/10/2020
    WalkInMeeting: "Walk-In-Meeting",
    WalkMessage: "Our operators are connected! You can meet us immediately:",
    StartMeeting: "Start meeting",
    //new added
    WaitingTime: "Waiting time",
    ArrivelTime: "Arrival time",
    AvailibleStaff: "Available staff",
    AppointmentTime: "Appointment time",
    StartRecording: "Start recording",
    EndCall: "End call",
    Participants: "Participants",
    MyAccount: "My account",
    MyBookingPage: "Booking page",
    MyMeetingDuration: "My meeting duration",
    //Add new
    UpdateDepartmentFlag: "Walk in status has been updated successfully",
    WalkinsMeetingText: 'We are connecting you with an operator now.',
    WalkinsMeetingNotConnect: 'Unfortunately we could not connect you to any operator. Please schedule a meeting at your convenience',
    ScheduleMeeting: 'Schedule a meeting',
    Newcallfrom: 'New call from',
    //added 2/11/2020
    Temp: "This block will contain search keypad contact history queue",
    ToBeDefine: "To be define",
    Mute: "Mute",
    OffVideo: "Stop video",
    StopScreen: "Stop screen",
    StartRecording: "Start recording",
    Invite: "Invite",
    Participates: "Participates",
    Queue: "Queue",
    AddNote: "Note has been added successfully",
    Note: "Note",
    NotePlaceholder: "Enter note",
    //new
    UserNoteDetails: "User note details",
    UserNote: "User note",
    ShareScreen: "Share screen",
    DismissAppointment: "Dismiss appointment has been successfully",
    StopRecording: "Stop recording",
    AlreadyScheduleMeeting: 'Already reschedule this appointment',
    Unmute: "Unmute",
    ConferenceMessage: "No conference started",
    //added new 13/10/2020
    Analytics: "Analytics",
    Walkin: "Walk in",
    Entrare: "Walk in",
    AcceptWalkin: "Accept walk in",
    Refresh: "Refresh",
    Type: "Type",
    Call: "Call",
    Dismiss: "Dismiss",
    WalkRoom: "Room busy, either merge call or upgrade your package for more rooms",
    Welcome1: "Welcome",
    Embed: 'Embed',
    Id: 'Id',
    Notes: 'Notes',
    //Added new 16/10/2020
    RescheduleURL: "Appointment reschedule URL",
    //added new 23/11/2020
    RecheduleUrlUpdate: "Rechedule Url has been updated successfully",
    AutomaticBookingConfirmation: "Automatic booking confirmation",
    //added new 23/11/2020
    AppointmentRequested: "Appointment requested",
    Confirmation: "You will receive the confirmation of the meeting via email at the address:",
    Requested: "has been requested",
    //added new 1/12/2020
    ClickHere: "Click here to ",
    DocumentView: " View document",
    DocumentType: " Document type",
    //15/12/2020
    Professional: "Professional",
    Enterprise: "Enterprise",
    Trial: "Trial",
    Activate: "Activate unio professionals",
    Activate1: "Activate your ",
    ActivateYourAccount: "Activate your account",
    YourPlan: "Your plan",
    ChangePlan: "Change plan",
    FreeTrial: "30 days free trial",
    UnioPremium: "Unio Premium",
    AfterTrial: "9.99&euro; /user /month after trial",
    Charged: "You wont be charged until ",
    OfferTerms: "Cancel anytime. Offer terms apply.",
    PaymentInfo: "Why do we ask for you payment info?",
    CreditorDebitCard: "Credit or debit card",
    CardNumber: "Card number",
    ExpirationDate: " Expiration date ",
    SecurityCode: "Security code ",
    Subscription1: "If you don't cancel your subscription before the trial end on",
    Subscription2: ", you agree that you will automatically be charged the subscription fee every month until you cancel.Full terms are available ",
    Here: "here",
    CardRequired: "Card number field is required",
    SecurityCodeRequired: "Security code field is required",
    YearRequired: "Year expire field is required",
    MonthRequired: "Month expire field is required",
    CardInvalid: "Card number is invalid",
    CvvInvalid: "Security code is invalid",
    ExpireMonth: "Expiry month is invalid",
    ExpireYear: "Expiry year is invalid",
    CardIncorrect: "Card number is incorrect",
    CardDeclined: "Card is not supported",
    CardUpdated: "Card has been updated successfully",
    CardTitle: "Card details Updated",
    CardFailed: "Failed to save Card id",
    PaymentInfoMessage1: "We ask for payment information so you can use Unio without interruptions, should you continue after the free period. If you cancel before the ",
    PaymentInfoMessage2: ", you won't be charged.",
    Remain1: "Since you have ",
    Remain2: " days remaining on your current plan.",
    SeatNotAvailable: "Seat not available",
    SeatDetails: "Seat details",
    UpgradeYourPlan: "Upgrade your plan",
    UpgradePlan: "Upgrade plan",
    Checkout: "Checkout",
    PlanPurchase: "Plan purchase",
    LeftoverBalance: "Leftover balance",
    FromYour: "from your current plan",
    Billed: "Billed monthly",
    YourNewPlan: "Your new plan",
    NextChargeDate: "Next charge date : ",
    SubmitPurchase: "Submit purchase",
    StandardPlan: "Standard plan ",
    SeatPlan: " seats",
    Seats: "Seats",
    Seat: "Seat",
    Total: "Total",
    SaveTransactionFailed: "Payment failed",
    SaveTransactionPlan: "Payment has been done successfully",
    PurchaseFailed: "Purchase failed",
    Pleasefillyourcarddetailsfirst: "Please fill your card details first",
    //12/01/21
    UnioSoftware: "Unio software",
    MaxNumberOfAppointment: "Max number of appointment",
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    MaxNumberOfAppointmentSuccess: "Data updated successfully",
    Unlimited: "Unlimited",
    TimeSlots: 'Time slots',
    SelectDay: 'Select day',
    applytoallthestaffmembers: 'Apply to all Staffs',
    //14/01/21
    UnioUsers: "Users",
    InmateName: "Inmate name",
    PrisonerSurname: "Prisoner surname",
    InmateIdentificationNumber: "Inmate identification number",
    DeleteUnioUserMessage: "Are you sure to delete the user?",
    UnioUserDeleted: "User has been deleted successfully",
    //15/01/21
    EditUnioUsers: "Edit users",
    SelectStaff: "Select staff",
    StaffAllocateSuccess: "Staff allocated successfully",
    AllocateStaff: "Allocate staff",
    NameOfInmate: "Name of the inmate",
    SurnameOfPrisoner: "Surname of the prisoner",
    UpdateUnioUserSuccess: "User has been updated successfully",
    Accepted: "Accepted",
    Rejected: "Rejected",
    Relation: "Relation",
    Document_1: "Document 1",
    Document_2: "Document 2",
    IsDevice: "Is device",
    // new added
    DeviceDetails: "Device details",
    Device: "Device",
    AddDevice: "Add device",
    DeviceName: "Select device",
    DeviceAdded: "Device has been added successfully.",
    LoginSuccess: "Login successfull",
    staffConferenceMessage1: "The appointment is not assigned to you.",
    staffConferenceMessage2: "Wait until the appointment is allocated to you by the moderator",
    StaffUrl: "Staff URL",
    StartDevice: "Start device",
    DeviceStarted: "Device has been started successfully.",
    Devices: "Devices",
    EditDevice: "Edit device",
    DevicesDeleteSuccess: "Device deleted successfully",
    DevicesUpdateSuccess: "Device updated successfully",
    DeleteDevicecMessage: "Are you sure to delete the device?",
    roles: {
      'Admin': 'Admin',
      'Staff': 'Staff',
      'Moderator': 'Moderator',
      'SuperModerator': 'Super Moderator'
    },
    lang: {
      'English': 'English',
      'Italian': 'Italian'
    },
    ShowDirectDepartment: 'Show direct department',
    //03-02-21
    IsPostpaid: "Is postpaid",
    AutoLogin: 'Auto login URL',
    InMates: 'In-Mates',
    AddInMates: 'Add in-Mate',
    EditInMates: 'Edit in-Mate',
    InMateDetails: 'In-Mate details',
    Blocked: 'Blocked',
    RecordingStarted: "Recording has been started successfully.",
    Address: 'Address of residence',
    HealthcareCardNumber: 'Healthcare card number',
    DegreeOfKinship: "Degree of kinship",
    DateOfBirth: "Date of birth",
    BirthPlace: "Birth place",
    RelativeDetails: 'Relative details',
    Relatives: 'Relatives',
    Block: 'Block',
    DevicesAddSuccess: "Device added successfully",
    Recording: "Recording",
    RecordingStatusUpdateSucess: "Recording status has been updated successfully",
    RecordingDetails: "Recording details",
    RecordingDelete: "Recording delete",
    RecordingDeleteSuccess: "Recording delete has been successfully",
    AppointmentId: 'Appointment id',
    DownloadRecording: 'Download recording',
    StopMeeting: 'Stop meeting',
    MeetingStop: 'Meeting has been stopped successfully!',
    DeleteRecordingMessage: 'Are you sure to delete this recording?',
    Recordings: "Recordings",
    FullName: "Full name",
    Time: "Time",
    RelationList: ['Spouse', 'Parent', 'Son/Daughter', 'Brother/Sister', 'Grandfather/a', 'Grandson', 'Uncle/a', 'Brother-in-law/a', 'Cousin/a', 'Father-in-law/a', 'Cohabitant', 'Acquaintance', 'Acquaintances / Third persons'],
    FamiltyRelationship: "Degree of kinship",
    FamiltyRelationshipPlaceholder: "Family relationship",

    UserBirthCity: "User born in",
    UserProvince: "User birth province",
    UserBirthday: "User birth date",

    InmateBirthCity: "Inmate born in",
    InmateProvince: "Inmate province",
    InmateBirthday: "Inmate date of birth",
    DeviceConferenceText: "The meeting is about to begin",
    WaitingFooterText: "Lecce prison house",
    StartTheCall: 'Start the meeting',
    StopTheCall: 'Stop meeting',
    InMate: 'In-Mate',
    SelectDevice: "Select device",
    //19/02/2021
    UseConfhub: "Use",
    errorMessage: `Your password should be at least 8 characters long, must contain at least
    lowercase letter, at least one uppercase letter and at least a number`,
    Surveillanc: 'Surveillance',
    // RoomsNotAvailable: 'There are no appointments in progress',
    RoomsNotAvailable: 'Rooms not available',
    Room: "Room",
    ShowCancelledMeetings: "Show cancelled meetings",
    ShowCompletedMeetings: "Show completed meetings",
    StartDate: 'Start date',
    EndDate: 'End date',
    SelectInMate: 'Select In-mate',
    SelectRelative: 'Select relative',
    Relative: 'Relative',
    RejectedByUser: "Rejected by user",
    PendingFromUser: "Pending from user",
    BookAppointment: "Book appointments",
    Hours: "Hours",
    Minutes: "Minutes",
    PreparationTime: "Preparation time",
    MaxPersonAppointment: "Maximum person appointment",
    ResidentIn: "Resident in",
    ProvinceResidance: "Province of residence",
    Street: "Street/Piazza/Strada",
    Apartment: `Apartment N interior and floor`,
    InmateBirthProvince: "Inmate birth province",
    LIVE: "To LIVE by the date",
    Habbit: "To habitually reside at ",
    UserCountryOfBirth: "User country of birth",
    InmateCountryOfBirth: "Inmate country of birth",
    NationalityLable: "Nationality",
    Specify: `Specify "reasonable reasons"`,
    NationalityList: {
      'Italian': 'Italian',
      'European': 'European',
      'Extraeuropean': 'Extraeuropean'
    },
    Book: "Book",
    Canceled: "Cancelled",
    //added 25/03/2021
    StatusUpdate: "Status updated",
    PhoneOrEmail: "Phone number or email",
    //added 26/03/2021
    RelationList: ['Spouse', 'Parent', 'Son/Daughter', 'Brother/Sister', 'Grandfather/a', 'Grandson', 'Uncle/a', 'Brother-in-law/a', 'Cousin/a', 'Father-in-law/a', 'Cohabitant', 'Acquaintance', 'Acquaintances / Third persons'],

    Coniuge: "Spouse",
    Genitore: "Parent",
    Figlioa: "Son/Daughter",
    FratelloSorella: "Brother/Sister",
    Nonnoa: "Grandfather/a",
    Nipote: "Grandson",
    Zioa: "Uncle/a",
    Cognatoa: "Brother-in-law/a",
    Cuginoa: "Cousin/a",
    Suoceroa: "Father-in-law/a",
    Convivente: "Cohabitant",
    Conoscente: "Acquaintance",
    ConoscentiTerzepersone: "Acquaintances / Third persons",

    Spouse: "Spouse",
    Parent: "Parent",
    SonDaughter: "Son/Daughter",
    BrotherSister: "Brother/Sister",
    Grandfathera: "Grandfather/a",
    Grandson: "Grandson",
    Unclea: "Uncle/a",
    Brotherinlawa: "Brother-in-law/a",
    Cousina: "Cousin/a",
    Fatherinlawa: "Father-in-law/a",
    Cohabitant: "Cohabitant",
    Acquaintance: "Acquaintance",
    AcquaintancesThirdpersons: "Acquaintances / Third persons",
    RemoteUser: "Remote user",
    TypeOfEvent: "Type of event",
    StaffUserName: "Staff user name",
    RemoteUserName: "Remote user name",
    DeviceNameValue: "Device name",
    CreatedDate: "Created date",
    AppointmentDate: "Date",
    TrackLogSetting: "Track log settings",
    DownloadPdf: "Download PDF",
    ActionList: {
      'USER_REGISTRATION': "User registration",
      'USER_APPROVAL': "User approval",
      'USER_REJECTION': "User rejection",
      'USER_BLOCKED': "User blocked",
      'COMPANION_REGISTRATION': "Companion registration",
      'COMPANION_APPROVAL': "Companion approval",
      'COMPANION_REJETION': "Companion rejection",
      'OTP_SENT': "OTP SENT",
      'OTP_WRONG': "OTP wrong",
      'OTP_ACCEPTED': "OTP accepted",
      'REMOTE_USER_LOGIN': "Remote user login",
      'STAFF_USER_LOGIN': "Staff user login",
      'REMOTE_USER_WRONG_PASSWORD': "Remote user wrong password",
      'STAFF_USER_WRONG_PASSWORD': "Staff user wrong passoword",
      "STAFF_USER_PASSWORD_SET": "Staff user password set",
      "STAFF_USER_PASSWORD_RESET": "Staff user password reset",
      "REMOTE_USER_PASSWORD_SET": "Remote user password set",
      "REMOTE_USER_PASSWORD_RESET": "Remote user password reset",
      'APPOINTMENT_REQUESTED': "Appointment requested",
      'APPOINTMENT_ACCEPTED': "Appointment accepted",
      'APPOINTMENT_REJECTED': "Appointment rejected",
      'APPOINTMENT_ACCEPTED_BY_REMOTE_USER': "Appointment Accepted by remote user",
      'APPOINTMENT_REJECTED_BY_REMOTE_USER': "Appointment Rejected by remote user",
      'STAFF_MEMBER_CREATED': "Staff member created",
      'DEPARTMENT_CREATED': "Department created",
      'INMATE_CREATED': "In-mate created",
      'STAFF_CONNECTED': 'Staff/Moderator connected',
      'STAFF_DISCONNECTED': 'Staff/Moderator disconnected',
      'DEVICE_CONNECTED': "Device connected",
      'DEVICE_DISCONNECTED': "Device Disconnected",
      'REMOTE_USER_CONNECTED_TO_THE_ROOM': "Remote user connected to the room",
      'REMOTE_USER_DISCONNECTED_FROM_THE_ROOM': "Remote user disconnected from the room",
      'CALL_BETWEEN_MODERATOR_AND_REMOTE_USER_STARTED': "Call between moderator and remote user started",
      'CALL_BETWEEN_REMOTE_USER_AND_DEVICE_STARTED': "Call between remote user and device started",
      'RECORDING_REQUETSTED': "Recording requested",
      "RECORDING_STARTED": "Recording started",
      "RECORDING_ACCESSED": "Recording accessed",
    },

    PinSetting: "Pin Setting",
    EnableSetting: "Enable pin for conference",
    Details: "Details",
    Join: "Join",
    With: "with",
    // Added 19/04/2020
    CustomDevice: "Customize the devices for audio and video",
    CallSettings: "CALL SETTINGS",
    AudioOutput: "Audio Output",
    Microphone: "Microphone",
    Camera: "Camera",
    LoadingConfrenceMessage: "Loading call settings....Please wait",
    staff_sms_reminder: "Staff SMS reminder",
    smtp_preference: "SMTP preference",
    //Added 29/04/2020
    Keypad: "Keypad",
    Prova: "Trial",
    Professionale: "Professional",
    LogoChange: "Change logo",
    BackgroundChange: "Change background",
    Note1: " Note : Please upload logo with  (256*60)  Size",
    Note2: " Note : Please upload Background image with (2400*1350) Size ",
    BackgroundImage: "Background image",
    LoaderChange: "Change loader",
    FaviconChange: "Change favicon",
    WaitingLogoChange: "Change waiting logo",
    Note3: "Note : Please upload loader image with (150*150) Size",
    Note4: "Note : Please upload favicon image with (16*16) Size",
    InstanceName: "Instance name",
    SettingUpdateSuccess: "Settings updated successfully",
    FooterUrl: "Footer URL",
    Copyright: "Copyright text",
    Search: "Search",
    //17/05/2021
    StaffD: "Staff/Department",
    //24/05/2021
    EmptyFilter: "There are no records matching your request.",
    EmptyData: "There are no records to show.",
    EmbedUrl: "Embed URL",
    // added 03/05/2021
    CropImage: "Crop",
    //added 4/6/2021
    AddNew: "Add new customer",
    AddAppointment: "Add appointment",
    BlockSuccess: "Time blocked Successfully",
    UnblockSuccess: "Time unblocked Successfully",
    BlockFailure: "You cannot block or add appointment in this period, It already contain an appointment",
    NewAppointment: "New appointment",
    OfferOptions: "Offer options",
    AnotherParticipate: "Another participate",
    Appointment: "Appointment",
    SelectSlots: "Select slots",
    //added 10/7/2021
    MailSuccessfull: "Mail sent to all users successfully",
    CompanyLogo: 'Company logo',
    //added 16/07/2021
    Map: "Map",
    AddressLink: "Address link",
    AddressUpdated: 'Address has been updated successfully',
    VideoConfereneType: "Video conference",
    InPerson: "In-Person conference",
    AppointmentType: "Appointment type",
    ChangeDevice: "Change device",
    //added 23/08/2021
    AddNotes: "Add note",
    AddNoteUser: "These internal notes are not visible to the user and can be useful to track important information about this meeting or the user.",
    IsEnableChat: "Enable chat",
    GroupChat: "Group chat",
    //added 31/08/2021 for start new conference on "+" button
    StaffMembers: "Staff members",
    StartNewConference: "Start new conference",
    SelectStaffMember: "Select staff member",
    StaffMember: "Staff member",
    Connect: "Connect",
    AddNewRoomMessage: "New conference started successfully",
    AddStaffConferenceMessage: "Staff member has been added successfully",
    ProfileImageUpdaeteSuccess: "Profile image updated successfully",
    MeetingIsFinished: "Meeting is finished",
    sender_name: "Sender name",
    NotificationSettingUpdate: "Notification setting updated successfully",
    NewCall: "New call",
    chooseFile: 'Choose a file',
    dragit: 'or drag it here',
    checkboxError: 'At least one answer must be checked'
  },


  it: {
    // Welcome: "Benvenuto in Unio",
    //added on 29/09/2021 user dashboard
    Welcome: "Benvenuti nell'applicazione per appuntamenti",
    Dashboard: 'Pannello di controllo',
    Companies: 'Aziende',
    Register: 'Registrati',
    ForgotPassword: 'Ho dimenticato la password?',
    ResetPassword: 'Reimposta la password',
    Error: 'Errore',
    404: '404',
    500: '500',
    Profile: 'Profilo',
    User: 'Utente',
    Users: 'Utenti totali',
    View: 'Vedi',
    Edit: 'Modifica',
    Import: 'Importa',
    Settings: 'Impostazioni',
    FirstName: 'Nome',
    LastName: 'Cognome',
    PrivacyPolicy: 'Norme sulla privacy',
    Cancel: 'Annulla',
    ContactNumber: "Numero di telefono",
    AdminLogin: 'Accesso amministratore',
    Email: 'Email',
    Password: "Parola d'ordine",
    Login: 'Accedi',
    LoginWelcome: 'Bentornato, accedi al tuo account.',
    Recoveryourpassword: 'Recupera la tua password',
    RecoveryourpasswordText: 'Inserisci il tuo indirizzo e-mail e ti invieremo le istruzioni su come reimpostare la password.',
    BackToLogin: 'Torna al login',
    RecoverPassword: 'Recupera la password',
    ResetPasswordText: 'Per favore inserisci la tua nuova password.',
    ConfirmPassword: 'Conferma Password',
    Reset: 'Ripristina',
    TotalCompanies: 'Aziende totali',
    //added new data
    Action: 'Azione',
    NA: 'N/A',
    StaffDetails: 'Dettagli del personale',
    Back: 'Indietro',
    AddStaff: 'Aggiungi personale',
    EditStaff: 'Modifica personale',
    Submit: 'Invia',
    Staffs: 'Personale',
    Departments: 'Reparti',
    Appointments: 'Appuntamenti',
    TotalStaffs: 'Totale Personale',
    TotalDepartments: 'Reparti totali',
    TotalAppointments: 'Appuntamenti totali',
    //14/09/2020
    TotalSms: 'SMS totali',
    SendOTP: "Invia OTP",
    ValidaionPhoneNumber: "OTP è stato inviato con successo",
    NotificationSettings: "Impostazioni di notifica",
    TrackingLogs: "Registri di monitoraggio",
    InvalidOTP: "OTP non valido",
    Title: "Titolo",
    Validate: "Convalidare",
    TitleName: "Nome del titolo",
    TitlePlaceholder: "Immettere il nome del titolo",
    OTPVerified: "OTP è stato verificato con successo",
    EnterOTP: 'Inserisci OTP',
    EnterOTPPlaceholder: 'Immettere segnaposto OTP',
    Enabled: "Abilitata",
    Disabled: "Disabilitata",
    Department: 'Reparto',
    Update: 'Aggiornare',
    Export: 'Esportare',
    Show: 'Mostrare',
    Delete: 'Elimina',
    Number: 'Numero',
    NoData: 'Nessun dato disponibile',
    CurrentStatus: 'Stato attuale',
    StatTime: 'Ora di inizio',
    Staff: 'Personale',
    Day: 'Giorno',
    Date: 'Data',
    StartTime: 'Orario inizio',
    EndTime: 'Orario fine',
    Add: 'Inserisci',
    AddDepartment: 'Aggiungi reparto',
    EditDepartment: 'Modifica reparto',
    DepartmentName: 'Nome Reparto',
    DepartmentPlaceholder: 'Inserisci il nome del reparto',
    Description: 'Descrizione',
    DescriptionPlaceholder: 'Inserisci la descrizione del reparto',
    BookingMessage: 'Messaggio di prenotazione',
    BookingMessagePlaceholder: 'Inserisci il messaggio di prenotazione',
    AppointmentDuration: 'Durata appuntamento in minuti',
    AppointmentDurationPlaceholder: "Inserisci la durata dell'appuntamento in minuti",
    CompanyLogin: "Login aziendale",
    //staff login
    TimeSlot: 'Fascia oraria',
    Slot: 'Slot',
    AddMore: 'Aggiungere altro',
    Save: 'Salva',
    SelectDate: 'Seleziona la data',
    CustomTimeSlot: 'Fascia oraria personalizzata',
    Logout: 'Disconnettersi',
    Change: 'Modificare',
    EditProfile: 'Modifica Profilo',
    CompanyName: 'Nome della ditta',
    OpeningHours: 'Orari di apertura',
    WelcomeMessage: 'Messaggio di benvenuto',
    HeaderFooter: 'Intestazione / piè di pagina',
    CompanyNamePlaceholder: "Inserisci il nome dell'azienda",
    PasswordPlaceholder1: 'La tua password',
    WelcomeMessagePlaceholder: 'Inserisci il messaggio di benvenuto',
    OpeningHoursPlaceholder: 'Inserisci gli orari di apertura',
    FirstNamePlaceholder: 'Inserisci il nome',
    LastNamePlaceholder: 'Inserisci il cognome',
    WelcomeToDashboard: 'Benvenuto in Dashboard',
    FailedToLogin: 'Accesso non riuscito',
    Incorrectpassword: 'Password errata',
    Emailnotregistered: 'Email non registrata',
    EmailSent: 'Email inviata',
    LinkSent: "Link inviato, controlla la tua email",
    PasswordReset: "Reimpostazione password eseguita correttamente",
    SetPassword: 'Impostare la password',
    InvalidToken: 'Token non valido',
    TokenExpired: 'Token scaduto',
    SignUp: 'Iscriviti',
    ThankYou: 'Grazie per la registrazione !!',
    ThankYouText: "La tua richiesta è in fase di approvazione, riceverai presto un'email.",
    Theemailhasalreadybeentaken: "L'email è già stata presa",
    emailalreadyexists: 'Email già esistente',
    ExportToExcel: 'Esportare in Eccellere',
    FileName: 'Inserisci il nome del file',
    CellAutoWidth: 'Larghezza automatica cella',
    Status: 'Stato',
    Approved: 'Approvato',
    DeleteCompany: 'Sei sicuro di eliminare questa azienda?',
    Yes: 'sì',
    No: 'No',
    CompanyDeleted: 'La società è stata eliminata correttamente',
    ApproveCompany: 'Sei sicuro di voler approvare questa azienda?',
    CompanyApproved: 'La società è stata approvata con successo',
    AddCompany: 'Aggiungi azienda',
    EmailPlaceholder: "Inserisci l'email",
    PasswordPlaceholder: 'Inserire la password',
    CompanySlug: 'Slug aziendale',
    CompanySlugPlaceholder: "Inserisci la lumaca dell'azienda",
    CompanyAdded: "La hase dell'azienda è stata aggiunta con successo",
    CompanyUpdated: 'La società è stata aggiornata con successo',
    EditCompany: 'Modifica azienda',
    Emailisalreadytakenpleasetrywithdiffrentemail: "L'e-mail è già in uso, prova con un'altra e-mail",
    Requestfailedwithstatuscode401: "Non autorizzato, effettua nuovamente l'accesso",
    ConfirmPasswordPlaceholder: 'Immettere Conferma password',
    FileUpload: 'Upload di file',
    Upload: 'Caricare',
    FileUploadError: 'Carica file con estensione .jpeg .jpg .png .gif.',
    ProfileUpdated: 'Il profilo è stato aggiornato con successo',
    ConfiredPasswordFailed: 'Password confermata non riuscita',
    SettingUpdated: "L'impostazione è stata aggiornata correttamente",
    CompanyNotFound: 'Impossibile trovare la società che stai cercando !!',
    Open: 'Aperto',
    Forenquiry: 'Per richiesta',
    SelectDataTime: 'Seleziona data e ora',
    SelectDataTime1: 'Oppure Seleziona data e ora',
    dayNames: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
    monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    TimeSlotNotAvailable: 'Fascia oraria non disponibile per questo reparto',
    Confirmed: 'Confermato',
    AppointmentBookedText: 'Il tuo appuntamento è programmato con',
    AppointmentBookedText1: 'Il tuo appuntamento con  ',
    AppointmentBookedTextUnio: 'Il prossimo appuntamento ',
    EmailReceive: "Riceverai il tuo nome utente e password via e-mail all'indirizzo",
    AddToCalender: 'Aggiungi al tuo calendario',
    Confirm: 'Confermare',
    EnterDetails: 'Inserisci i dettagli',
    AccountText: 'Se hai un account puoi',
    EventScheduled: 'Evento pianificato con successo!',
    UserRegistredSuceessfullybutstaffnotavailable: 'Utente registrato correttamente ma personale non disponibile',
    RoomError: 'Camera non disponibile!!',
    ScheduleEvent: 'Programma evento',
    Pending: 'In sospeso',
    Completed: 'Completato',
    Complete: 'Completare',
    CancelAppointment: 'Annulla l\'appuntamento',
    Reason: 'Motivo',
    EnterReason: 'Inserisci motivo',
    Accept: 'Accettare',
    AppointmentAcceptSucess: 'Appuntamento accettato con successo',
    AppointmentAccept: 'Appuntamento accettato',
    Reject: 'Rifiutare',
    AppointmentRejectedSucess: 'Appuntamento rifiutato con successo',
    AppointmentRejected: 'Appuntamento rifiutato',
    RejectAppointment: 'Rifiuta appuntamento',
    AppointmentCanceledSucess: 'Appuntamento annullato correttamente',
    WantToCompletedStatus: 'Sei sicuro di voler completare lo stato di questo appuntamento del personale?',
    AppointmentCanceled: 'Appuntamento annullato',
    AppointmentCompleted: 'Appuntamento completato',
    AppointmentMarkedCompleted: 'Appuntamento contrassegnato come completato',
    FailedToUpdateStatus: 'Aggiornamento dello stato non riuscito',
    AppointmentDetails: 'Dettagli dell \'appuntamento',
    ConferenceLink: 'Collegamento alla conferenza',
    ConferencePin: 'Pin conferenza',
    ProfileUpdate: 'Aggiornamento del profilo',
    ProfileUpdateSuccess: 'Profilo aggiornato con successo',
    FailedToFetchUsers: 'Impossibile recuperare gli utenti',
    TimeSlotAdded: 'Fascia oraria aggiunta correttamente',
    StartDateError: 'L\'ora di inizio non dovrebbe essere  nell\'intervallo dell\'intervallo  di tempo selezionato ',
    StartDateRangeError: 'L\'ora di inizio non dovrebbe essere  nell\'intervallo dell\'intervallo  di tempo selezionato ',
    StartTimeLessErr: 'L\'ora di inizio dovrebbe essere  inferiore all\'ora di  fine',
    EndtDateError: 'L\'ora di fine non dovrebbe essere  nell\'intervallo   dell\'intervallo di tempo  selezionato ',
    EndDateRangeError: 'L\'ora di inizio non dovrebbe essere  nell\'intervallo   dell\'intervallo di tempo   selezionato',
    EndTimeLessError: 'L\'ora di fine dovrebbe essere  maggiore dell\'ora di  inizio',
    StaffDeleted: "Il personale è stato cancellato con successo",
    DeleteStaffMessage: "Vuoi cancellare lo Personale?",
    SelectDepartments: 'Seleziona Reparti',
    DepartmentError: 'Il campo Reparti è obbligatorio',
    StaffAdded: 'Lo staff è stato aggiunto con successo',
    StaffUpdated: 'Il personale è stato aggiornato con successo',
    Duration: 'Durata',
    DepartmentDeleted: "Il reparto è stato cancellato con successo",
    DeleteDepartmentMessage: "Sei sicuro di eliminare il reparto?",
    DepartmentAdded: "Il reparto è stato aggiunto con successo",
    DepartmentUpdated: "Il reparto è stato aggiornato con successo",
    monday: 'Lunedi',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedi',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    Monday: 'Lunedi',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedi',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica',
    Lunedi: 'Monday',
    Martedì: 'Tuesday',
    Mercoledì: 'Wednesday',
    Giovedi: 'Thursday',
    Venerdì: 'Friday',
    Sabato: 'Saturday',
    Domenica: 'Sunday',
    //rahul added
    StaffLogin: "Login personale",
    Rights: 'Tutti i diritti riservati',
    DefaultSlot: 'Slot predefinito',
    CustomSlot: 'Slot personalizzato',
    //new added
    Youraccountisnotbeenapprovedyetpleasecontactadmin: "Il tuo account non è stato ancora approvato, contatta l'amministratore",
    Yourcardnumberisincomplete: 'Il numero della tua carta è incompleto.',
    Yourcardsexpirationyearisinthepast: "L'anno di scadenza della tua carta è passato.",
    Yourcardssecuritycodeisincomplete: "Il codice di sicurezza della tua carta è incompleto.",
    Yourcardnumberisinvalid: 'Il numero della tua carta non è valido.',
    Yourcardsexpirationdateisincomplete: "La data di scadenza della tua carta è incompleta.",
    Yourpostalcodeisincomplete: 'Il tuo codice postale è incompleto.',
    Yourcardisnotsupported: 'La tua carta non è supportata.',
    CardHolderName: 'Nome del titolare',
    CardNumber: 'Numero di carta',
    ExpiryDate: 'Data di scadenza',
    CardCVC: 'Card CVC',
    PaymentDetails: 'Dettagli di pagamento',
    PayNow: 'Paga ora',
    PaymentMsg: 'Questo appuntamento richiede un pagamento. Puoi pagare usando la tua carta di debito o di credito.',
    OnDate: 'Alla data',
    ContactText: 'Se hai qualche domanda su cui puoi contattare ',
    AppointmentBooked: 'Appuntamento prenotato',
    CreditDebitCard: 'Carta di credito o di debito',

    Pay: 'Pagare',
    Name: 'Nome',
    Amount: "Quantità",
    AmountPlaceholder: "Inserire l'importo",
    Currency: "Moneta",
    CurrencyPlaceholder: "Seleziona la valuta",
    //new added 27/07/2020
    PaymentStatus: "Stato del pagamento",
    Paid: "Pagato",
    NotPaid: "Non pagato",
    //new added 29/07/2020
    UserRegistredSuceessfullybutstaffnotavailable: "Utente registrato correttamente ma personale non disponibile",
    UserLoggedInSuccessfullybutstaffnotavailable: 'Utente connesso correttamente ma personale non disponibile',
    SettingSlot: "Impostazione della fascia oraria",
    Paymentfailed: 'Pagamento fallito, si prega di riprovare!',
    AppointmentNotFound: 'Appuntamento non trovato',
    //added 4/08/2020
    Payments: "Pagamenti",
    Company: "Azienda",
    PaymentDate: "Data di pagamento",
    UserDetails: "Dettagli dell'utente",
    DepartmentDetails: "Dettagli del reparto",
    CompanyDetails: "Dettagli della Compagnia",
    PaymentId: "ID pagamento",
    //added 7/08/2020
    SelectSplitBy: "Seleziona Dividi per",
    SelectDateRange: "Seleziona Intervallo di date",
    TotalRevenue: 'Entrate totali',
    //added 13/08/2020
    Today: "Oggi",
    Last7Days: "Ultimi 7 giorni",
    LastMonth: "Lo scorso mese",
    CurrentMonth: "Corrente mese",
    LastYear: "L'anno scorso",
    CurrentYear: "Anno corrente",
    TodaysRevenue: "Entrate odierne",
    Last7DaysRevenue: "Entrate degli ultimi 7 giorni",
    LastMonthRevenue: "Entrate del mese scorso",
    CurrentMonthRevenue: "Entrate del mese corrente",
    LastYearRevenue: "Entrate dello scorso anno",
    CurrentYearRevenue: "Entrate dell'anno in corso",
    TodaysAppointment: "Appuntamento di oggi",
    Last7DaysAppointment: "Appuntamento negli ultimi 7 giorni",
    LastMonthAppointment: "Appuntamento lo scorso mese",
    CurrentMonthAppointment: "Appuntamento del mese corrente",
    LastYearAppointment: "Appuntamento dell'anno scorso",
    CurrentYearAppointment: "Appuntamento per l'anno in corso",

    // added 11/08/2020
    SelectStatus: "Seleziona Stato",
    TotalRevenue: 'Entrate totali',
    AppointmentStatus: "Stato dell'appuntamento",
    Unpaid: 'Non pagato',
    Revenue: 'Reddito',
    //17/08/2020
    Rooms: "Stanze",
    CreateRoom: "Crea stanza",
    CreateRoomPlaceholder: "Crea nuova stanza",
    RoomName: "Nome della stanza",
    DeleteRoom: "Sei sicuro di eliminare la stanza?",
    RoomDeleted: "La stanza è stata eliminata con successo",
    RoomAdded: "La stanza è stata aggiunta con successo",
    RoomPin: 'Perno',
    //added 19/08/2020
    LatestAppointment: "Ultimo appuntamento",
    SystemSettings: 'Impostazioni whitelabel',
    SelectPlan: 'Seleziona piano',
    Plan: ' Piano',
    SystemSettingsUpdated: 'Le impostazioni di Whitelabel sono state aggiornate correttamente',
    RoomAddress: 'Indirizzo della stanza',
    Embed: 'Incorporare',
    MaxParticipants: 'Max partecipanti',
    Upgrade: 'Upgrade',
    RoomUpdated: 'La stanza è stata aggiornata con successo',
    DurationUpdated: 'La durata della riunione è stata aggiornata correttamente',
    CopyText: 'Copia con successo',
    CopyTextError: 'Impossibile copiare il codice',
    AppError: 'Appuntamento non trovato',

    EditRoom: 'Modifica stanza',
    EmbedCode: 'Incorpora appuntamento del libro',
    //added 27/08/2020
    URLMessage: "URL in cui è incorporato il codice",
    PaymentDone: 'Il pagamento è stato effettuato con successo',
    //28/08/2020
    ClearTimeSlot: "Cancella intervallo di tempo con successo",
    Clear: "Cancella slot",
    Ordinary: 'Ordinario',
    Exceptions: 'Eccezioni',
    Workshift: 'Turno di lavoro',
    OrdinaryWorkshift: 'Turno di lavoro ordinario',
    SelectWeekDays: 'Seleziona giorni della settimana',
    OpeningDays: 'Giorni di apertura',
    OpeningTime: 'Orario di apertura',
    ClosingTime: 'Orario di chiusura',

    Days: "Giorni",
    OridinaryExplainationBox: 'Definisci la tua settimana lavorativa. In base alla tua settimana lavorativa, la piattaforma calcolerà il tuo tempo disponibile e programmerà gli appuntamenti per te. Puoi definire più slot nello stesso giorno della settimana, ad esempio uno al mattino e uno al pomeriggio, lasciando una pausa pranzo a metà.',
    ExceptionsExplainationBox: 'Qui puoi definire le eccezioni alla tua settimana lavorativa ordinaria. Se hai richiesto un permesso per un giorno specifico, puoi selezionare la data e rimuovere o modificare il relativo turno di lavoro.',
    //02/09/2020
    DirectURL: "URL diretto",
    MeetingDuration: "Durata della riunione",
    Duration: "Durata",
    VisiblityUpdated: "La visibilità è stata aggiornata con successo",
    StatusUpdated: "Lo stato è stato aggiornato con successo",
    Visiblity: "Visibilità",
    monday: 'Lunedi',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedi',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    //03/09/2020
    Free: "Gratuita",
    SetVisibility: 'Imposta visibilità',
    RemoveVisibility: 'Rimuovi visibilità',
    PremiumMeeting: "Riunione premium",
    DepartmentSlug: "Reparto Slug",
    DepartmentSlugPlaceholder: "Segnaposto Reparto Lumaca",
    //04/09/2020
    Copy: "Copia",
    //new added 7/09/2020
    AppointmentStatistics: "Statistiche degli appuntamenti",
    weekDays: ['Lunedi', 'Martedì', 'Mercoledì', 'Giovedi', 'Venerdì', 'Sabato', 'Domenica'],
    ManyToMany: "Molti a molti",
    Booked: 'Già prenotato',
    BookedAppointmentText: 'Il tuo appuntamento è già stato prenotato',

    UserNotConnect: "Il meeting non è ancora iniziato. Per favore aspetta che l'organizzatore lo apra.",
    ScheduleAt: 'è in programma alle',
    DidNotConnected: 'non si è ancora connesso',
    StartWithVideo: 'Inizia con il video',
    StartWithMicroPhone: 'Inizia con microphone',
    StartTheMeeting: 'Inizia la riunione',
    Absent: "Assente",
    Present: "Presente",
    On: "On",
    Off: "Off",
    Welcome1: "Benvenuto",
    //16/09/2020
    Meeting: "Incontro",
    SelectMeeting: "Seleziona riunione",
    TypeOfMeeting: "Tipo di riunione",
    TypeOfMeetingPlaceholder: "Seleziona tipo di riunione",
    FreeMeeting: "Incontro gratuito",
    OneToOne: "Uno a uno",
    Onetoone: "Uno a uno",
    Unoauno: "Uno a uno",
    Conference: "Conferenza",
    Conferenza: "Conferenza",

    EmbedYourWebsite: 'Incorpora nel tuo sito web',
    CompnayId: "Codice Identificativo dell'azienda",
    AppointmentBookingWidget: 'Widget per la prenotazione degli appuntamenti',
    AppointmentBookingWidgetText: 'Questo è il widget di prenotazione degli appuntamenti per questa azienda. Copia e incolla questo codice nella pagina del tuo sito web in cui desideri incorporare il sistema di appuntamenti.',
    MeetingRoomWidget: 'Widget della sala riunioni',
    MeetingRoomWidgetText: "Questo widget è diverso per ogni stanza perché contiene l'ID stanza. Seleziona la stanza che desideri incorporare e copia e incolla questo codice nella pagina del tuo sito web in cui desideri incorporare quella stanza. Quindi inserisci l'URL in cui hai incorporato la stanza, così sappiamo dove inviare i partecipanti alle riunioni.",
    RoomURL: 'URL della stanza sul tuo sito web',
    UserOnline: 'è in linea',
    UserOffline: 'è offline',
    Offline: 'Disconnesso',
    Online: 'in linea',
    BookingForm: 'Modulo di prenotazione',
    first_name: 'Nome',
    last_name: 'Cognome',
    email: 'Email',
    contact_number: 'Numero di contatto',
    company_name: 'Azienda',
    gender: 'Genere',
    age: 'Età',
    dob: 'Data di nascita',
    country: 'Nazione',
    city: 'Città',
    document: 'Documento di identità',
    Passport: 'Passaporto',
    IdentityCard: "Carta d'identità",
    DrivingLicense: "Patente di guida",
    custom_field_one: 'Personalizzato 1',
    custom_field_two: 'Personalizzato 2',
    Custom1Label: 'Etichetta personalizzata 1',
    Custom2Label: 'Etichetta personalizzata 2',
    EnterLabel: 'Inserisci etichetta',
    FieldsSaved: 'I campi sono stati aggiornati correttamente',
    Male: 'Maschio',
    Female: 'Femmina',
    Maschio: "Male",
    Femmina: "Female",

    Prefernottosay: 'Preferisco non dirlo',
    Enter: 'Accedere ',
    Select: 'Selezionare ',
    //24/09/2020
    SMTP: "SMTP",
    Server: "Server",
    ServerAddress: "Indirizzo del server",
    ServerPlaceholder: "Immettere l'URL del server",
    Port: "Porta",
    PortPlaceholder: "Entra in porto",
    UserName: "Nome utente",
    UserNamePlaceholder: "Inserire username",
    SenderEmailAddress: "Email del mittente",
    SenderEmailPlaceholder: "Immettere l'email del mittente",
    UseUnio: "Utente unio",
    UseOwn: "Usa proprio",
    SelectSMTP: "Seleziona SMTP",
    SMTPAdded: 'SMTP è stato aggiunto con successo',
    SMTPUpdated: 'SMTP è stato aggiornato correttamente',
    //Added 28/09/2020
    TimeZone: "Fuso orario",
    SelectTimeZone: "Seleziona fuso orario",
    TimeZoneAdded: 'Il fuso orario è stato aggiunto con successo',
    TimeZoneUpdated: 'Il fuso orario è stato aggiornato correttamente',
    //Added 1/10/2020
    Shown: "Mostrato",
    Mandatory: "Obbligatoria",
    //31/08/2020
    DeleteUser: 'Sei sicuro di eliminare questo utente?',
    UserDetails: 'Dettagli utente',
    UserDeleted: "L'utente è stato eliminato con successo",
    User1: "Utenti",
    SelectLanguage: "Seleziona la lingua",
    Language: "Lingua",
    English: "inglese",
    Italian: "Italiana",
    //5/10/2020
    VideoConfereceEngine: "Motore di videoconferenza",
    VideoConferece: "Video conferenza",
    EnginePlaceholder: "Entra in Video Conference Engine",
    Domain: "Dominio",
    DomainPlaceholder: "Immettere il dominio",
    VideoConferenceUpdated: "La videoconferenza è stata aggiornata correttamente",
    //9/10/2020
    Month: "Mese",
    Year: "Anno",
    Week: "Settimana",
    //15/10/2020
    Role: "Ruolo",
    SelectRole: "Seleziona ruolo",
    Admin: "Admin",
    //new 22/10/2020
    AppointmentBookedText2: 'Il tuo appuntamento con ',
    //add new 28/10/2020
    EnterPassword: 'Inserire la password',
    //new added 29/10/2020
    WalkInMeeting: "Walk-in-meeting",
    WalkMessage: "I nostri operatori sono connessi! Puoi incontrarci immediatamente:",
    StartMeeting: "Avvia riunione",
    WaitingTime: "Tempo di attesa",
    ArrivelTime: "Orario di arrivo",
    AvailibleStaff: "Staff disponibile",
    AppointmentTime: "Ora dell'appuntamento",
    StartRecording: "Inizia a registrare",
    EndCall: "Fine chiamata",
    Participants: "Partecipante",
    MyAccount: "Il mio account",
    MyBookingPage: "La mia pagina di prenotazione",
    MyMeetingDuration: "Durata della mia riunione",
    UpdateDepartmentFlag: "Lo stato di Walk in è stato aggiornato correttamente",
    WalkinsMeetingText: 'ti stiamo collegando con un operatore ora.',
    WalkinsMeetingNotConnect: 'Purtroppo non siamo riusciti a metterti in contatto con nessun operatore. Si prega di programmare una riunione a proprio piacimento',
    ScheduleMeeting: 'Pianificare una riunione',
    Newcallfrom: 'Nuova chiamata da',
    //add new 2/11/2020
    Temp: "Questo blocco conterrà la coda della cronologia dei contatti della tastiera di ricerca",
    ToBeDefine: "Da definire",
    Mute: "Muta",
    OffVideo: "Interrompi video",
    ShareScreen: "Condividere lo schermo",
    EndCall: "Fine chiamata",
    Invite: "Invitare",
    Participates: "Partecipa",
    Queue: "Coda",
    AddNote: "La nota è stata aggiunta con successo",
    Note: "Nota",
    NotePlaceholder: "Inserisci nota",
    UserNoteDetails: "Dettagli nota utente",
    UserNote: "Nota dell'utente",
    DismissAppointment: "Ignora l'appuntamento è stato eseguito correttamente",
    StopRecording: "Interrompi la registrazione",
    StopScreen: "Stop screen",
    AlreadyScheduleMeeting: 'Already Reschedule this appointment',
    Unmute: "Riattiva",
    ConferenceMessage: "Nessuna conferenza iniziata",
    //added new 13/10/2020
    Analytics: "Analytics",
    Walkin: "Entrare",
    Entrare: "Entrare",
    AcceptWalkin: "Accetta entrare",
    Refresh: "Ricaricare",
    Type: "Genere",
    Call: "Chiamata",
    Dismiss: "Respingere",
    WalkRoom: "Stanza occupata, unisci la chiamata o aggiorna il tuo pacchetto per più stanze",
    Welcome1: "Benvenuto",
    Notes: 'Appunti',
    Id: 'Id',
    //Added new 16/10/2020
    RescheduleURL: "URL riprogrammazione appuntamento",
    //added new 23/11/2020
    RecheduleUrlUpdate: "Riprogramma URL è stato aggiornato correttamente",
    AutomaticBookingConfirmation: "Conferma automatica della prenotazione",
    //added new 23/11/2020
    AppointmentRequested: "Appuntamento richiesto",
    Confirmation: "Riceverai la conferma dell'incontro via mail all'indirizzo:",
    Requested: "è stato richiesto",
    //added new 1/12/2020
    ClickHere: "Clicca qui per ",
    DocumentView: " Visualizza documento ",
    DocumentType: " Tipo di documento",
    //15/12/20
    Professional: "Professionale",
    Enterprise: "Enterprise",
    Trial: "Prova",
    Prova: "Prova",
    Professionale: "Professionale",
    RoomError1: "La camera è piena, si prega di contattare l'amministratore",
    Activate: "Attiva i professionisti di Unio",
    Activate1: "Attiva il tuo",
    ActivateYourAccount: "Attiva il tuo account",
    YourPlan: "il tuo piano",
    ChangePlan: "Cambiare piano",
    FreeTrial: "30 giorni di prova gratuita",
    UnioPremium: "Unio premium",
    AfterTrial: "9,99 $ / utente / mese dopo la prova",
    Charged: "Non ti verrà addebitato fino all ",
    OfferTerms: "annullare in qualsiasi momento si applicano i termini dell'offerta",
    PaymentInfo: "Perché ti chiediamo informazioni sul pagamento?",
    CreditorDebitCard: "Carta di credito o di debito",
    CardNumber: "Numero di carta",
    ExpirationDate: " Data di scadenza ",
    SecurityCode: "Codice di sicurezza ",
    Subscription1: "Se non annulli l'abbonamento prima della fine del periodo di prova l",
    Subscription2: ",accetti che ti verrà addebitato automaticamente il costo dell'abbonamento ogni mese fino all'annullamento ",
    Here: "qui",
    CardRequired: "Il campo del numero della carta è obbligatorio",
    SecurityCodeRequired: "Il campo del codice di sicurezza è obbligatorio",
    YearRequired: "Il campo Scadenza anno è obbligatorio",
    MonthRequired: "Il campo Scadenza mese è obbligatorio",
    CardInvalid: "Il numero della carta non è valido",
    CvvInvalid: "Codice di sicurezza non valido",
    ExpireMonth: "Il mese di scadenza non è valido",
    ExpireYear: "L'anno di scadenza non è valido",
    CardIncorrect: "Il numero della carta non è corretto",
    CardDeclined: "La carta non è supportata",
    CardUpdated: "L'ID della carta è stato aggiornato correttamente",
    CardTitle: "Dettagli della carta aggiornati",
    CardFailed: "Impossibile salvare l'ID della carta",
    PaymentInfoMessage1: "Chiediamo le informazioni di pagamento in modo che tu possa utilizzare Unio senza interruzioni, se continui dopo il periodo gratuito.Se annulli prima del ",
    PaymentInfoMessage2: ",non ti verrà addebitato.",
    Remain1: "Dal momento che hai ",
    Remain2: " giorni rimanenti nel piano corrente.",
    SeatNotAvailable: "Posto non disponibile",
    SeatDetails: "Dettagli del sedile",
    UpgradeYourPlan: "Aggiorna il tuo piano",
    UpgradePlan: "Piano di aggiornamento",
    Checkout: "Check-out",
    PlanPurchase: "Piano di acquisto",
    LeftoverBalance: "Saldo residuo",
    FromYour: "dal tuo piano attuale",
    Billed: "fatturato mensilmente",
    YourNewPlan: "Il tuo nuovo piano",
    NextChargeDate: "Prossima data di addebito : ",
    SubmitPurchase: "Invia acquisto",
    StandardPlan: "Piano standard ",
    SeatPlan: " posti a sedere",
    Seats: "Posti a sedere",
    Seat: "Posto a sedere",
    Total: "Totale",
    SaveTransactionFailed: "Salvataggio transazione non riuscito",
    SaveTransaction: "Salva transazione",
    SaveTransactionPlan: "Il salvataggio della transazione è stato eseguito correttamente",
    PurchaseFailed: "Acquisto fallito",
    Pleasefillyourcarddetailsfirst: "Si prega di inserire prima i dati della carta",
    //12/01/21
    UnioSoftware: "Software unio",
    MaxNumberOfAppointment: "Numero massimo di appuntamenti",
    Daily: "Quotidiana",
    Weekly: "settimanalmente",
    Monthly: "Mensile",
    MaxNumberOfAppointmentSuccess: "Dati aggiornati correttamente",
    Unlimited: "Illimitato",
    TimeSlots: 'Time slots',
    SelectDay: 'Select day',
    applytoallthestaffmembers: 'Applica a tutto il blocco',
    //14/01/21
    UnioUsers: "Utenti",
    InmateName: "Nome detenuto",
    PrisonerSurname: "Cognome del detenuto",
    InmateIdentificationNumber: "Numero di identificazione del detenuto",
    DeleteUnioUserMessage: "Sei sicuro di eliminare l'utente?",
    UnioUserDeleted: "L'utente è stato eliminato con successo",
    //15/01/21
    EditUnioUsers: "Modifica utenti",
    SelectStaff: "Seleziona Detenuto",
    StaffAllocateSuccess: "Personale assegnato con successo",
    AllocateStaff: "Assegna risorsa",
    NameOfInmate: "Nome detenuto",
    SurnameOfPrisoner: "Cognome del detenuto",
    UpdateUnioUserSuccess: "L'utente è stato aggiornato con successo",
    Accepted: "Accettato",
    Rejected: "Respinto",
    Relation: "Nessuna azione intrapresa",
    Document_1: "Documento 1",
    Document_2: "Documento 2",
    IsDevice: "È un dispositivo",
    // new added
    DeviceDetails: "Dettagli del dispositivo",
    Device: "Dispositivo",
    DeviceNam: "Seleziona dispositivo",
    DeviceAdded: "Il dispositivo è stato aggiunto con successo.",
    AddDevice: "Aggiungi dispositivo",
    LoginSuccess: "Accesso riuscito",
    staffConferenceMessage1: "L'appuntamento non è assegnato a te.",
    staffConferenceMessage2: "Attendi che l'appuntamento ti venga assegnato dal moderatore",
    StaffUrl: "Url del personale",
    StartDevice: "Avvia dispositivo",
    DeviceStarted: "Il dispositivo è stato avviato con successo.",
    Devices: "Dispositivi",
    EditDevice: "Modifica dispositivo",
    DevicesDeleteSuccess: "Dispositivi eliminati con successo",
    DevicesUpdateSuccess: "Dispositivi aggiornati correttamente",
    DeleteDevicecMessage: "Sei sicuro di voler eliminare il dispositivo?",
    roles: {
      'Admin': 'Admin',
      'Staff': 'Personale',
      'Moderator': 'Moderatore',
      'SuperModerator': 'Super moderatore'
    },
    lang: {
      'English': 'Inglese',
      'Italian': 'Italiano'
    },
    ShowDirectDepartment: 'Mostra reparto diretto',
    //03-02-21
    IsPostpaid: "è postpagato",
    AutoLogin: 'URL di accesso automatico',
    InMates: 'Detenuti',
    AddInMates: 'Aggiungi detenuto',
    EditInMates: 'Modifica detenuto',
    InMateDetails: 'Dettagli detenuto',
    Blocked: 'bloccato',
    RecordingStarted: "La registrazione è stata avviata con successo",
    Address: 'Indirizzo di residenza',
    HealthcareCardNumber: 'Numero tessera sanitaria',
    DegreeOfKinship: "Grado di parentela",
    DateOfBirth: "Data di nascita",
    BirthPlace: "Luogo di Nascita",
    RelativeDetails: 'Dettagli relativi',
    Relatives: 'Parenti',
    Block: 'Bloccare',
    DevicesAddSuccess: "Dispositivo aggiunto con successo",
    Recording: "Registrazione",
    RecordingStatusUpdateSucess: "Lo stato della registrazione è stato aggiornato correttamente",
    RecordingDetails: "Dettagli di registrazione",
    RecordingDelete: "Cancellazione registrazione",
    RecordingDeleteSuccess: "La cancellazione della registrazione è stata eseguita correttamente",
    AppointmentId: 'Appuntamento Id',
    DownloadRecording: 'Scarica registrazione',
    StopMeeting: 'Interrompi riunione',
    MeetingStop: 'La riunione è stata interrotta correttamente!',
    RecordingDetails: "Dettagli di registrazione",
    RecordingDelete: "Cancellazione registrazione",
    RecordingDeleteSuccess: "La cancellazione della registrazione è stata eseguita correttamente",
    DeleteRecordingMessage: 'Sei sicuro di voler eliminare questa registrazione?',
    Recordings: "Registrazioni",
    DownloadRecording: "Scarica registrazione",
    Recordings: "Registrazioni",
    FullName: "Nome e cognome",
    Time: "Tempo",
    RelationList: ['Coniuge', 'Genitore', 'Figlio/a', 'Fratello/Sorella', 'Nonno/a', 'Nipote', 'Zio/a', 'Cognato/a', 'Cugino/a', 'Suocero/a', 'Convivente', 'Conoscente', 'Conoscenti/Terze persone'],
    FamiltyRelationship: "Grado di parentela",
    FamiltyRelationshipPlaceholder: "Rapporto di parentela",

    UserBirthCity: "Utente nato in",
    UserProvince: "Provincia di nascita dell'utente",
    UserBirthday: "Data di nascita dell'utente",

    InmateBirthCity: "Detenuto nato a",
    InmateProvince: "Provincia del detenuto",
    InmateBirthday: "Data di nascita del detenuto",
    DeviceConferenceText: "La riunione sta per iniziare",
    WaitingFooterText: "Casa Circondariale Lecce",
    StartTheCall: 'Avvia la chiamata',
    StopTheCall: 'Ferma la chiamata',
    InMate: 'Detenuti',
    SelectDevice: "Seleziona dispositivo",
    //19/02/2021
    UseConfhub: "Usa",
    errorMessage: `La tua password deve essere lunga almeno 8 lettere, contenere
    almeno una lettera minuscola, una lettera maiuscola ed un numero`,
    Surveillanc: 'Sorveglianza',
    RoomsNotAvailable: 'Non ci sono appuntamenti in corso',
    // Room: "Camera",
    ShowCancelledMeetings: "Mostra riunioni annullate",
    ShowCompletedMeetings: "Mostra riunioni completate",
    StartDate: 'Data inizio',
    EndDate: 'Data fine',
    SelectInMate: 'Seleziona in-mate',
    SelectRelative: 'Seleziona relativo',
    Relative: 'Parente',
    RejectedByUser: "Rifiutato dall'utente",
    PendingFromUser: "In attesa da utente",
    BookAppointment: "Prenota appuntamenti",
    Hours: "Ore",
    Minutes: "Minuti",
    PreparationTime: "Tempo di preparazione",
    MaxPersonAppointment: "Numero massimo di persone nominative",
    ResidentIn: "Residente in",
    ProvinceResidance: "Province of residence",
    Street: "Via/Piazza/Strada",
    Apartment: `Appartamento N interno e piano`,
    InmateBirthProvince: "Provincia di nascita dei detenuti",
    LIVE: "di CONVIVERE dalla data",
    Habbit: "di dimorare abitualmente presso:",
    UserCountryOfBirth: "Paese di nascita dell'utente",
    InmateCountryOfBirth: "Paese di nascita del detenuto",
    NationalityLable: "Cittadinanza",
    Specify: `Specificare "ragionevoli motivi"`,
    NationalityList: {
      'Italian': 'Italiana',
      'European': 'Europea',
      'Extraeuropean': 'Extraeuropea'
    },
    //
    Book: "Prenota",
    Canceled: "Annullato",
    //added 25/03/2021
    StatusUpdate: "Stato aggiornato",
    PhoneOrEmail: "Numero di telefono o e-mail",
    //added 26/03/2021
    Coniuge: "Coniuge",
    Genitore: "Genitore",
    Figlioa: "Figlio/a",
    FratelloSorella: "Fratello/Sorella",
    Nonnoa: "Nonno/a",
    Nipote: "Nipote",
    Zioa: "Zio/a",
    Cognatoa: "Cognato/a",
    Cuginoa: "Cugino/a",
    Suoceroa: "Suocero/a",
    Convivente: "Convivente",
    Conoscente: "Conoscente",
    ConoscentiTerzepersone: "Conoscenti/Terze persone",

    Spouse: "Coniuge",
    Parent: "Genitore",
    SonDaughter: "Figlio/a",
    BrotherSister: "Fratello/Sorella",
    Grandfathera: "Nonno/a",
    Grandson: "Nipote",
    Unclea: "Zio/a",
    Brotherinlawa: "Cognato/a",
    Cousina: "Cugino/a",
    Fatherinlawa: "Suocero/a",
    Cohabitant: "Convivente",
    Acquaintance: "Conoscente",
    AcquaintancesThirdpersons: "Conoscenti/Terze persone",
    RemoteUser: "Utente remoto",
    TypeOfEvent: "Tipo di evento",
    StaffUserName: "Nome utente staff",
    RemoteUserName: "nome utente remoto",
    DeviceNameValue: "Nome del dispositivo",
    CreatedDate: "Data di Creazione",
    AppointmentDate: "Data",
    TrackLogSetting: "Impostazioni del registro di traccia",
    DownloadPdf: "Scarica il PDF",
    ActionList: {
      'USER_REGISTRATION': "Registrazione utente",
      "USER_APPROVAL": "Approvazione utente",
      "USER_REJECTION": "Rifiuto dell'utente",
      "USER_BLOCKED": "Utente bloccato",
      "COMPANION_REGISTRATION": "Registrazione companion",
      "COMPANION_APPROVAL": "Approvazione companion",
      "COMPANION_REJETION": "Rifiuto azienda",
      "OTP_SENT": "OTP inviato",
      "OTP_WRONG": "OTP errato",
      "OTP_ACCEPTED": "OTP accettata",
      "REMOTE_USER_LOGIN": "Accesso utente remoto",
      "STAFF_USER_LOGIN": "Login utente personale",
      "REMOTE_USER_WRONG_PASSWORD": "Password errata utente remoto",
      "STAFF_USER_WRONG_PASSWORD": "Password errata dell'utente del personale",
      "REMOTE_USER_PASSWORD_SET": "Password utente remoto impostata",
      "REMOTE_USER_PASSWORD_RESET": "Reimpostazione della password dell'utente remoto",
      "STAFF_USER_PASSWORD_SET": "Password utente personale impostata",
      "STAFF_USER_PASSWORD_RESET": "Reimpostazione della password dell'utente personale",
      "APPOINTMENT_REQUESTED": "Appuntamento richiesto",
      "APPOINTMENT_ACCEPTED": "Appuntamento accettato",
      "APPOINTMENT_REJECTED": "Appuntamento rifiutato",
      'APPOINTMENT_ACCEPTED_BY_REMOTE_USER': "Appuntamento accettato dall'utente remoto",
      'APPOINTMENT_REJECTED_BY_REMOTE_USER': "Appuntamento rifiutato dall'utente remoto",
      "STAFF_MEMBER_CREATED": "Membro dello staff creato",
      "DEPARTMENT_CREATED": "Reparto creato",
      "INMATE_CREATED": "In-mate creato",
      'STAFF_CONNECTED': 'Staff/moderatore connesso',
      'STAFF_DISCONNECTED': 'Staff/moderatore disconnesso',
      "DEVICE_CONNECTED": "Dispositivo connesso",
      'DEVICE_DISCONNECTED': "Dispositivo disconnesso",
      "REMOTE_USER_CONNECTED_TO_THE_ROOM": "Utente remoto connesso alla stanza",
      "REMOTE_USER_DISCONNECTED_FROM_THE_ROOM": "Utente remoto disconnesso dalla stanza",
      'CALL_BETWEEN_MODERATOR_AND_REMOTE_USER_STARTED': "Chiamata tra moderatore e utente remoto avviata",
      'CALL_BETWEEN_REMOTE_USER_AND_DEVICE_STARTED': "Chiamata tra utente remoto e dispositivo avviata",
      "RECORDING_REQUETSTED": "Registrazione richiesta",
      "RECORDING_STARTED": "Registrazione avviata",
      "RECORDING_ACCESSED": "Accesso alla registrazione",
    },
    PinSetting: "Impostazione dei pin",
    EnableSetting: "Abilita pin per conferenza",
    Details: "Dettagli",
    Join: "Aderire",
    With: "con",
    // Added 19/04/2020
    CustomDevice: "Personalizza i dispositivi per audio e video",
    CallSettings: "Impostazioni di chiamata",
    AudioOutput: "Uscita audio",
    Microphone: "Microfono",
    Camera: "Telecamera",
    LoadingConfrenceMessage: "Caricamento delle impostazioni di chiamata in corso ... Attendere",
    staff_sms_reminder: "Promemoria SMS per il personale",
    smtp_preference: "Preferenza SMTP",
    //Added 29/04/2020
    Keypad: "Tastiera",
    LogoChange: "Cambia logo",
    BackgroundChange: "Cambia sfondo",
    Note1: "Nota: Carica il logo con una dimensione di (256*60) ",
    Note2: "Nota: Carica l'immagine di sfondo con una dimensione di (2400*1350) ",
    BackgroundImage: "Immagine di sfondo",
    LoaderChange: "Cambia caricatore",
    FaviconChange: "Cambia Favicon",
    WaitingLogoChange: "Cambia logo in attesa",
    Note3: "Nota: caricare l'immagine del caricatore con dimensioni (150 * 150)",
    Note4: "Nota: carica un'immagine favicon con dimensioni (16 * 16)",
    InstanceName: "Nome istanza",
    SettingUpdateSuccess: "Impostazioni aggiornate con successo",
    FooterUrl: "URL piè di pagina",
    Copyright: "Diritto d'autore text",
    Search: "Ricerca",
    //17/05/2021
    StaffD: "Personale/Reparto",
    //24/05/2021
    EmptyData: "Non ci sono record da mostrare.",
    EmptyFilter: "Non ci sono record corrispondenti alla tua richiesta.",
    EmbedUrl: "Incorpora URL",
    // added 03/05/2021
    CropImage: "Ritaglia",
    //added 4/6/2021
    AddNew: "Aggiungi nuovo cliente",
    BlockSuccess: "Tempo bloccato con successo",
    UnblockSuccess: "Tempo sbloccato con successo",
    BlockFailure: "Non puoi bloccare o aggiungere un appuntamento in questo periodo, contiene già un appuntamento",
    NewAppointment: "Nuovo appuntamento",
    AddAppointment: "Aggiungi appuntamento",
    OfferOptions: "Opzioni di offerta",
    AnotherParticipate: "Un altroPartecipa",
    Appointment: "Appuntamento",
    SelectSlots: "Seleziona slot",
    //added 10/7/2021
    MailSuccessfull: "Posta inviata a tutti gli utenti con successo",
    CompanyLogo: 'Logo della compagnia',
    //added 16/07/2021
    Map: "Carta geografica",
    AddressLink: "Link indirizzo",
    AddressUpdated: "L'indirizzo è stato aggiornato con successo",
    VideoConfereneType: "Video conferenza",
    InPerson: "Conferenza di persona",
    AppointmentType: "Tipo di appuntamento",
    ChangeDevice: "Cambia dispositivo",
    //added 23/08/2021
    AddNoteUser: "Queste note interne non sono visibili all'utente e possono essere utili per tenere traccia di informazioni importanti su questa riunione o sull'utente.",
    AddNotes: "Aggiungi nota",
    IsEnableChat: "Abilita chat",
    GroupChat: "Chat di gruppo",
    //added 31/08/2021 for start new conference on "+" button
    StaffMembers: "Membri dello staff",
    StartNewConference: "Inizia una nuova Conferenza",
    SelectStaffMember: "Seleziona membro dello staff",
    StaffMember: "Membro dello staff",
    Connect: "Collegare",
    AddNewRoomMessage: "Nuova Conferenza iniziata con successo",
    AddStaffConferenceMessage: "Il membro dello staff è stato aggiunto con successo",
    ProfileImageUpdaeteSuccess: "Immagine del profilo aggiornata con successo",
    MeetingIsFinished: "L'incontro è finito",
    sender_name: "Nome del mittente",
    NotificationSettingUpdate: "Impostazioni di notifica aggiornate con successo",
    //added on 25/10/2021
    CopyLink: 'Copia collegamento operatore',
    Download: "Scarica",
    NewCall: "Nuova chiamata",
    chooseFile: 'Scegli un file',
    dragit: 'o trascinalo qui',
    checkboxError: "È necessario selezionare almeno una risposta"
  }
}
